/** @jsx h */
import { h } from 'preact'
import Slider from './Slider'

const Journey = props =>
  <Slider {...props.data} />

export default Journey
